import { ORCHESTRATOR_ACTIONS } from '../../common/events/orchestratorEvents'
import { getPortForProduct } from '../../common/utils/urls'
import { getActiveProduct } from '../../exports/Navigator/utils/getActiveProductFromUrl'

export default [
  {
    id: 'connect-channel',
    section: 'go to',
    name: 'Connect channel',
    shortcut: ['n', 'c'],
    keywords: 'new channel',
    perform: (): void => {
      ORCHESTRATOR_ACTIONS.openChannelStorefront({
        cta: `${getActiveProduct()}-launcher-connectChannel-nc-1`,
      })
    },
  },
  {
    id: 'analytics',
    name: 'Analytics',
    section: 'go to',
    shortcut: ['g', 'a'],
    keywords: 'analytics, analyze',
    perform: (): void => {
      const [, ...domain] = window.location.hostname.split('.')
      const port = getPortForProduct('analyze')
      const newUrl = `https://analyze.${domain.join('.')}${port}`
      return window.location.assign(newUrl)
    },
  },
  {
    id: 'engagement',
    section: 'go to',
    name: 'Engagement',
    shortcut: ['g', 'e'],
    keywords: 'engagement',
    perform: (): void => {
      const [, ...domain] = window.location.hostname.split('.')
      const port = getPortForProduct('engage')
      const newUrl = `https://engage.${domain.join('.')}${port}`
      return window.location.assign(newUrl)
    },
  },
  {
    id: 'start-page',
    section: 'go to',
    name: 'Start Page',
    shortcut: ['g', 's'],
    keywords: 'start page',
    perform: (): void => {
      const [, ...domain] = window.location.hostname.split('.')
      const port = getPortForProduct('start-page')
      const newUrl = `https://start-page.${domain.join('.')}${port}`
      return window.location.assign(newUrl)
    },
  },
  {
    id: 'feature-request',
    section: 'go to',
    name: 'Submit Feature Request',
    keywords: 'feedback feature',
    // shortcut: ['n', 'i'],
    perform: (): void => {
      window.open('https://buffer.com/feature-request', '_blank')
    },
  },
  {
    id: 'help-center',
    section: 'go to',
    name: 'Help Center',
    keywords: 'help support customer',
    // shortcut: ['n', 'i'],
    perform: (): void => {
      window.open(
        'https://support.buffer.com?utm_source=buffer&utm_medium=command-launcher&utm_campaign=command-launcher',
        '_blank',
      )
    },
  },
  {
    id: 'whats-new',
    section: 'go to',
    name: "What's New",
    keywords: 'whats new updates',
    // shortcut: ['n', 'i'],
    perform: (): void => {
      window.open('https://buffer.com/whats-new', '_blank')
    },
  },
  {
    id: 'get-in-touch',
    section: 'go to',
    name: 'Get in touch',
    keywords: 'help support customer',
    // shortcut: ['n', 'i'],
    perform: (): void => {
      window.open(
        'https://support.buffer.com/?openContact=true&utm_source=buffer&utm_medium=command-launcher&utm_campaign=command-launcher',
        '_blank',
      )
    },
  },
]
